var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobsDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.774,
    height: 22.774,
    viewBox: "0 0 22.774 22.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M11.387,0A11.387,11.387,0,1,1,0,11.387,11.387,11.387,0,0,1,11.387,0Z",
    fill: "#7e7e7e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Close_Sharp",
    "data-name": "Icon / Close / Sharp",
    transform: "translate(2.387 2.387)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 18,
    height: 18,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M10.5-12.95,9.45-14,5.25-9.8,1.05-14,0-12.95l4.2,4.2L0-4.55,1.05-3.5l4.2-4.2,4.2,4.2L10.5-4.55,6.3-8.75Z",
    transform: "translate(3.75 17.75)",
    fill: "#f3f3f3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsDeleteIcon);
export default __webpack_public_path__ + "static/media/jobs-delete-icon.6305c110d1270f79a2285ebfc80aebd4.svg";
export { ForwardRef as ReactComponent };